module.exports = __webpack_public_path__ + "static/media/DubaiW23-Bold.f2d182c5.ttf";